import BaseGetters from '@/store/base/getters'
import DocumentsGetters from "@/store/base/documents/getters";

export default BaseGetters({
  //
}, [DocumentsGetters])
